import React, { useState, useEffect } from 'react';
import {
  FlexBox,
  FlexBoxHorizontal,
  TextField,
} from '../../atoms';
import {
  SelectAllCheckBox,
} from '../../molecules';
import { Filter } from '../../organisms';
import styled from 'styled-components';

const StyleColorImgFilter = ({ data, onSearch, brd_cd }) => {
      // 날짜를 YYMMDD 형식으로 포맷하는 함수
      const formatDate = () => {
        const now = new Date();
        const year = now.getFullYear().toString().slice(-2); // 마지막 2자리
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const date = now.getDate().toString().padStart(2, '0');
        return `${year}${month}${date}`;
      };

      const filterOptions = {
            ...data,
            searchValue: null,
          };
      const [selectedOptions, setSelectedOptions] = useState([]);
      const [isDownloading, setIsDownloading] = useState(false);

      useEffect(() => {
        // filterOptions가 업데이트된 후 sesn의 첫 번째 옵션을 자동으로 선택하고 onSearch 호출
        const newSelectedOptions = {
          ...filterOptions,
          sesn: filterOptions.sesn && filterOptions.sesn[0] ? [filterOptions.sesn[0]] : [], // 첫 번째 sesn 옵션 선택
        };
    
        setSelectedOptions(newSelectedOptions);
        onSearch(newSelectedOptions);  // 선택된 옵션을 onSearch에 전달
      }, [data]); // data가 변경될 때마다 호출
    

      const handleSelectedOptions = (key, value) => {
            setSelectedOptions((prev) => ({
              ...prev,
              [key]: value,
            }));
            onSearch({ ...selectedOptions, [key]: value });
          };

      const handleExcelDownload = async () => {
        try {
          setIsDownloading(true);
          const sesnValues = selectedOptions.sesn?.map(item => item.value) || [];
          const response = await fetch('/api/style-color-img/download-excel', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ brd_cd: 'X', sesn: sesnValues }),
          });
          if (!response.ok) {
            throw new Error('Excel 다운로드 실패');
          }
          const blob = await response.blob();
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = `Raw Data_${formatDate()}.xlsx`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
          console.error('Excel 다운로드 중 오류 발생:', error);
          alert('Excel 다운로드 중 오류가 발생했습니다.');
        } finally {
          setIsDownloading(false);
        }
      };

  return (
      <Filter style={{ height: '60px', flexDirection: 'column' }}>
      <FlexBoxHorizontal style={{ justifyContent: 'space-between', overflow: 'auto' }}>
          <FlexBox>
          {data.sesn.length > 0 ? <>
            <div
            style={{
              width: '160px',
              margin: '0 10px 0 20px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.sesn}
              setSelected={(value) => handleSelectedOptions('sesn', value)}
              options={filterOptions.sesn}
              title={'시즌'}
              allSelectTitle="시즌 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '160px',
              margin: '0 10px 0 0px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.parentPrdtKind}
              setSelected={(value) => handleSelectedOptions('parentPrdtKind', value)}
              options={filterOptions.parentPrdtKind}
              title={'대분류'}
              allSelectTitle="대분류 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '160px',
              margin: '0 10px 0 0px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.prdtKind}
              setSelected={(value) => handleSelectedOptions('prdtKind', value)}
              options={filterOptions.prdtKind}
              title={'중분류'}
              allSelectTitle="중분류 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '160px',
              margin: '0 10px 0 0px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.item}
              setSelected={(value) => handleSelectedOptions('item', value)}
              options={filterOptions.item}
              title={'아이템'}
              allSelectTitle="아이템 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '170px',
              margin: '0 10px 0 0px',
            }}
          >
            <SelectAllCheckBox
              selected={selectedOptions.adultKid}
              setSelected={(value) => handleSelectedOptions('adultKid', value)}
              options={filterOptions.adultKid}
              title={'성인키즈'}
              allSelectTitle="성인키즈 All"
              isMulti
            />
          </div>
          <div
            style={{
              width: '170px',
              marginRight: '10px',
            }}
          >
            <TextField
              placeholder="품번/제품명/컬러 "
              onChange={(value) => handleSelectedOptions('searchValue', value)}
            />
          </div></>: null}
          </FlexBox> 
          {brd_cd === 'X' ? (<FlexBox style={{ gap: '8px', alignItems: 'center' }}>
            <span style={{ 
              fontSize: '12px', 
              fontWeight: '500', 
              color: '#666',
              letterSpacing: '0.5px'
            }}>
              EXCEL Download
            </span>
            <ExcelDownloadButton
              onClick={() => handleExcelDownload()}
              disabled={isDownloading}
              $isDownloading={isDownloading}
              style={{ marginRight: '20px' }}
            >
              <span>Style</span>
            </ExcelDownloadButton>
          </FlexBox>) : null}
          </FlexBoxHorizontal>
      </Filter>
  );
};

export default StyleColorImgFilter;

const ExcelDownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  height: 24px;
  min-width: 58px;
  background: ${props => props.$isDownloading ? '#e0e0e0' : 'rgb(136, 136, 136)'};
  color: ${props => props.$isDownloading ? '#999' : 'white'};
  border: none;
  border-radius: 6px;
  cursor: ${props => props.$isDownloading ? 'not-allowed' : 'pointer'};
  font-family: 'NotoSansKR-Regular', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 10px !important;
  line-height: 1;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background:rgba(90, 98, 104, 0.89);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  &:active:not(:disabled) {
    background: #495057;
    transform: translateY(0.5px);
  }
  
  &:disabled {
    opacity: 1;
  }
  
  /* 텍스트 스타일 */
  span {
    font-size: 11px !important;
    line-height: 1;
    letter-spacing: 0.3px;
  }
`;